<template>
  <v-col cols="12" :md="md">
    <v-container class="ml-2">
      <v-row>
        <h6>{{$t('common:media_plural')}}</h6>
      </v-row>
      <v-row>
        <p>{{$t('common:tags')}}:</p> <p class="color-class-pink">{{tags}}</p>
      </v-row>
      <v-row>
        <p>{{$t('display/elevator:statistic.blocked-for')}}:</p> <p class="color-class-pink">{{blackTags}}</p>
      </v-row>
      <v-row>
        <p></p>
      </v-row>
      <v-row>
        <p></p>
      </v-row>
      <v-row>
        <p></p>
      </v-row>
      <v-row>
        <p></p>
      </v-row>
      <v-row>
        <p>{{$t('display/elevator:statistic.first-revenue')}}:</p>
        <p class="color-class-pink"> {{firstRevenue}}</p>
      </v-row>
      <v-row>
        <p>{{$t('display/elevator:statistic.statistic-generated')}}:</p>
        <p class="color-class-pink"> {{item.elevatorStatistic.lastStatisticAt}}</p>
      </v-row>
    </v-container>
  </v-col>
</template>
<script>
export default {
  name: "AdditionalField",
  props: {
    item: Object,
    md: String
  },
  data() {
    return {
      tags: '',
      blackTags: '',
      firstRevenue: '~'
    }
  },
  created() {
    let tags = '';
    for(let i = 0; i < this.item.elevator.tags.length; i++) {
      tags += this.item.elevator.tags[i].name + ', ';
    }
    this.tags = tags.slice(0, -2);

    let blackTags = '';
    for(let i = 0; i < this.item.elevator.blackTags.length; i++) {
      tags += this.item.elevator.blackTags[i].name + ', ';
    }
    this.blackTags = blackTags.slice(0, -2);

    if (this.item.elevatorStatistic.firstRevenueAt !== null) {
      this.firstRevenue = this.item.elevatorStatistic.firstRevenueAt;
    }
  }
}
</script>

<style scoped>
.color-class-blue {
  color: #23afec
}
.color-class-pink {
  color: #e2017b;
}
.color-class-green {
  color: #20a648;
}
</style>